<template>
  <v-slide-x-transition mode="out-in">
    <LoadingListPlaceholder v-if="isLoading">
      <slot name="mock" />
    </LoadingListPlaceholder>
    <EmptyListPlaceholder
      :height="emptyHeight"
      :message="emptyMessage"
      :message-size="emptyMessageSize"
      :icon="emptyIcon"
      :icon-size="emptyIconSize"
      v-else-if="isEmpty"
    />
    <slot v-else name="content" />
  </v-slide-x-transition>
</template>

<script>
import LoadingListPlaceholder from "@/components/base/LoadingListPlaceholder"
import EmptyListPlaceholder from "@/components/base/EmptyListPlaceholder"
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: true
    },
    isEmpty: {
      type: Boolean,
      default: true
    },
    emptyMessage: {
      type: String,
      default: "No informations found"
    },
    emptyMessageSize: {
      type: Number,
      default: 20
    },
    emptyIcon: {
      type: String,
      default: "mdi-alert-circle-outline"
    },
    emptyHeight: {
      type: Number,
      default: 100
    },
    emptyIconSize: {
      type: Number,
      default: 70
    }
  },
  components: {
    LoadingListPlaceholder,
    EmptyListPlaceholder
  }
}
</script>

<style lang="scss" scoped></style>
